module.exports = __webpack_public_path__ + "static/media/data-review.ac5cdd28.png";